import { noop } from '@tanstack/react-query';
import type { LoaderFunctionArgs } from 'react-router';
import { invitationsOptions } from '@/services/invitations';
import { requestsOptions } from '@/services/requests';
import { rosterOptions } from '@/services/roster';
import { settingsOptions } from '@/services/settings';
import { queryClientContext } from './query-client-context';

/**
 * Entering `/clients`: the roster is the page frame, so the navigation waits
 * for it; invitations, requests, and the
 * coach's settings only start. No read fails the navigation:
 * the page shows each one's own error state, with a retry.
 */
export async function clientsLoader({ context }: LoaderFunctionArgs) {
  const queryClient = context.get(queryClientContext);
  void queryClient.query(invitationsOptions()).catch(noop);
  void queryClient.query(requestsOptions()).catch(noop);
  // The invite dialog opens with the coach's default message already there.
  void queryClient.query(settingsOptions()).catch(noop);
  await queryClient
    .query({ ...rosterOptions(), staleTime: 'static' })
    .catch(noop);
  return null;
}
